import db, { storage, auth } from '../firebase/firebase'
import firebase from "firebase/compat/app"
import moment from 'moment'

const Api = {

    loginAdmin: (email, password, success, error) => {
        auth.signInAnonymously()
            .then(() => {
                console.log('signedInAnonymously');
                db.collection("admin")
                    .where("email", "==", email)
                    .where("password", "==", password)
                    .get()
                    .then(querySnapshot => {
                        const data = querySnapshot.docs.map(doc => doc.data());
                        if (data.length > 0) {
                            let user = data[0];
                            success(user)
                        }
                        else {
                            error('Could not login')
                        }
                    });
            })
            .catch((error) => {
                error('Could not login')
            });
    },

    updateAdmin: (email, password, success, error) => {
        db.collection('admin')
            .doc('admin')
            .set({
                email: email,
                password: password,
                updated_on: firebase.firestore.FieldValue.serverTimestamp()
            }, { merge: true })
            .then(() => {
                success()
            })
            .catch(e => {
                error('Update failed!')
            });
    },

}

export default Api;
